import { FmvAttributeVisualizerComponent } from "../../components/shared/organization/camera-list/fmv-attribute-visualizer/fmv-attribute-visualizer.component";
import { BaseEntityAttribute } from "./base-entity-attribute";

export class FmvEntityAttribute extends BaseEntityAttribute {
  constructor(
    attributeName: string,
    mapEntityId: string,
    order: number,
    public fmvFeed: any // Replace 'any' with your FmvFeed type if available
  ) {
    super(attributeName, mapEntityId, true, true, order);
  }

  override getDirective(): any {
    return {
        component: FmvAttributeVisualizerComponent,
        inputs: {
        mapentityid: this.mapEntityId,
        fmvfeedid: this.fmvFeed?.getId?.() ?? ''
        }
    };
    }

  getFmvFeed(): any {
    return this.fmvFeed;
  }
}